/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestNinjaOneConnectionRequest
 */
export interface TestNinjaOneConnectionRequest {
    /**
     * Optional OAuth2 client id to test (uses stored value if not provided)
     */
    clientId?: string;
    /**
     * Optional new client secret to test (uses stored secret if not provided)
     */
    clientSecret?: string;
    /**
     * Optional region to test (uses stored region if not provided)
     */
    region?: TestNinjaOneConnectionRequestRegionEnum;
}


/**
 * @export
 */
export const TestNinjaOneConnectionRequestRegionEnum = {
    Eu: 'eu',
    Us: 'us',
    Ca: 'ca',
    Oc: 'oc',
} as const;
export type TestNinjaOneConnectionRequestRegionEnum = typeof TestNinjaOneConnectionRequestRegionEnum[keyof typeof TestNinjaOneConnectionRequestRegionEnum];


/**
 * Check if a given object implements the TestNinjaOneConnectionRequest interface.
 */
export function instanceOfTestNinjaOneConnectionRequest(value: object): value is TestNinjaOneConnectionRequest {
    return true;
}

export function TestNinjaOneConnectionRequestFromJSON(json: any): TestNinjaOneConnectionRequest {
    return TestNinjaOneConnectionRequestFromJSONTyped(json, false);
}

export function TestNinjaOneConnectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestNinjaOneConnectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'clientSecret': json['clientSecret'] == null ? undefined : json['clientSecret'],
        'region': json['region'] == null ? undefined : json['region'],
    };
}

export function TestNinjaOneConnectionRequestToJSON(json: any): TestNinjaOneConnectionRequest {
    return TestNinjaOneConnectionRequestToJSONTyped(json, false);
}

export function TestNinjaOneConnectionRequestToJSONTyped(value?: TestNinjaOneConnectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'region': value['region'],
    };
}

